import React from 'react';
import './BundlePricingSection.css';

const plans = [
  {
    name: 'eBook',
    price: 'Rs. 149',
    includes: ['Top 50 Online Business Ideas eBook (PDF)'],
    featured: true,
  },
];

const BundlePricingSection = ({ sectionNumber = '04' }) => (
  <section className="pricing-section" id="pricing" title={sectionNumber}>
    <div className="pricing-container">
      <div className="pricing-header">
        <h2>eBook Pricing</h2>
        <p>Get instant access to the full eBook for a one-time payment of just Rs. 149.</p>
      </div>

      <div className="pricing-grid">
        {plans.map((plan) => (
          <article key={plan.name} className={`pricing-card${plan.featured ? ' is-featured' : ''}`}>
            <h3>{plan.name}</h3>
            <p className="pricing-amount">{plan.price}</p>
            <ul>
              {plan.includes.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default BundlePricingSection;
